<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :resourceName="$tc('resources.lead.name', 1)"
                ref="table"
            >
                <template #company="{ item }">
                    <template v-if="item.cnpj">
                        <span class="caption">
                            {{ $t('resources.lead.attributes.trade_name') }}:
                        </span>
                        <span class="body-2 font-weight-medium">{{
                            item.trade_name
                        }}</span>
                        <br />
                        <span class="caption"
                            >{{ $t('resources.lead.attributes.legal_name') }}:
                        </span>
                        <span class="body-2">{{ item.legal_name }}</span>
                        <br />
                    </template>

                    <template v-else>
                        <span class="caption">
                            {{ $t('resources.lead.attributes.name') }}:
                        </span>
                        <span class="body-2 font-weight-medium">{{
                            item.trade_name
                        }}</span>
                        <br />
                    </template>

                    <span class="caption">
                        {{ $t('resources.lead.attributes.cpf') }}:
                    </span>
                    <span class="body-2">{{ item.document }}</span>
                    <br />
                </template>

                <template #customer_trade_name="{ item }">
                    <template v-if="item.hasCustomer">
                        <router-link
                            :to="{
                                name: 'customer.show',
                                params: { id: item.customer.id },
                            }"
                            >{{ item.customer.trade_name }}</router-link
                        >
                    </template>
                    <template v-else>-</template>
                </template>

                <template #contacts="{ item }">
                    <span class="caption">
                        {{ $t('resources.lead.attributes.email') }}:
                    </span>
                    <span class="body-2">{{ item.email }}</span>
                    <br />
                    <span class="caption">
                        {{ $t('resources.lead.attributes.phone') }}:
                    </span>
                    <span class="body-2">{{ item.phone }}</span>
                    <br />
                </template>

                <template #actionHandler>
                    <LeadAction
                        ref="actionHandler"
                        @modelChanged="$refs.table.getItems()"
                    />
                </template>
            </sarala-table>
        </v-row>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Lead from '@/models/Lead'
import LeadAction from '../../components/actions/lead/LeadAction.vue'

export default {
    components: {
        LeadAction,
        SaralaTable,
    },

    computed: {
        model() {
            return new Lead()
        },
    },
}
</script>

<style></style>
